import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { processInt } from '../../global';
import { getAdvices, initialData } from '../../services/shipperadviceservice';
import { setLoading } from '../../redux/appSlice';
import { setGrid, setOriginalGrid, setReattempts, setCalltracks, setData } from '../../redux/shipperAdviceSlice';
import Grid from './grid';
import { getMultipleSubAccountLocations } from '../../services/userservice';

const Form = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => { return { appData: state.appData, shipperAdviceData: state.shipperAdviceData } });
    const { userInfo, loading, accounts, subaccounts } = state.appData;
    const {
        data,
        calltracks,
        reattempts,
        grid,
        originalGrid
    } = state.shipperAdviceData;

    const [subAccountsLocal, setSubAccountsLocal] = useState([]);
    const [locations, setLocations] = useState([]);
    const updateData = (key, val) => {
        const d = { ...data, [key]: val };
        dispatch(setData({ data: d }));
    };

    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const init = async (id, data, source) => {
            dispatch(setLoading({ data: true }));
            const initdatars = await initialData(id, source);
            const advicesrs = await getAdvices(data, source);
            dispatch(setLoading({ data: false }));


            if (initdatars.sts == 0) {

                dispatch(setCalltracks({ data: initdatars.data.calltracks }));
                dispatch(setReattempts({ data: initdatars.data.reattempts }));
            }

            if (advicesrs.sts == 0) {
                dispatch(setGrid({ data: advicesrs.data }));
                dispatch(setOriginalGrid({ data: advicesrs.data }));

            }
        }

        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: subaccounts.map(e => e.id)})

            if (locs.length > 0) {
                
                setLocations(locs);
                const d = { ...data, from: data.from ? data.from : null, to: data.to ? data.to : null, accountNo: accounts.join(), LocationID: locs.map(e => e.value)  };
                init(userInfo.id, d, source);
        
                //dispatch(setData({ data: { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id], LocationID: [+locs[0].value] } }));
            } else {
                const d = { ...data, from: data.from ? data.from : null, to: data.to ? data.to : null, accountNo: accounts[0] };
                init(userInfo.id, d, source);
        
                //dispatch(setData({ data: { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id] } }));
            }
        }


        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    const onSearch = async () => {

        if (data.from && data.to) {
            if (Date.parse(data.from) > Date.parse(data.to)) {
                alert('Invalid Date');
                return;
            }
        }

        if (data.type === 2) {
            if (!data.cn && (!data.from || !data.to)) {
                alert('Enter Date Range or Consignment No');
                return;
            }
        }

        if (data.LocationID.length === 0) {
                alert('Please select location.');
                return;
        }

        const d = { ...data, accountNo: data.Account.join(), from: data.from ? data.from : null, to: data.to ? data.to : null };
        dispatch(setLoading({ data: true }));
        const advicesrs = await getAdvices(d);
        dispatch(setLoading({ data: false }));
        if (advicesrs.sts == 0) {
            dispatch(setGrid({ data: advicesrs.data }));
            dispatch(setOriginalGrid({ data: advicesrs.data }));
        }
    }


    useEffect(() => {
        dispatch(setGrid({ data: [] }));
        dispatch(setOriginalGrid({ data: [] }));
    }, [data.type])

    return <>
        {
            (calltracks && calltracks.length > 0) && (reattempts && reattempts.length > 0) &&
            <div>
                <div className="row pb-2">
                    <div className="col">
                        <label>Account</label>
                        <select className="form-select" multiple value={data.Account} onChange={async (e) => {
                            let value = Array.from(e.target.selectedOptions, option => option.value);
                            let d = { ...data, Account: value };
                            if (value && value.length > 0) {
                                const subAccs = subaccounts.filter(e => value.includes(e.accountNo.toUpperCase()));
                                setSubAccountsLocal(subAccs);
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                                d.subAccountId =  [subAccs[0].id];
                    
                                if (locs.length > 0) {
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                    d.LocationID = [];
                                }
                            } else {
                                setLocations([]);
                                d.LocationID = [];
                            }
                            dispatch(setData({ data: d}));
                        }}>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>
    
                    <div className="col-lg">
                        <label>Sub Account</label>
                        <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                            const selectedOptions = Array.from(e.target.selectedOptions);
    
                            const accnos = selectedOptions
                                .map(option => option.getAttribute('data-accno'))
                                .filter(acc => acc && acc.trim() !== '');
                    
                            const uniqueAccnos = Array.from(
                                new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                            );
    
                            const val = Array.from(new Set(
                                selectedOptions
                                    .map(option => option.value)
                                    .filter(v => v && !isNaN(v))
                                    .map(v => parseInt(v))
                            ));
    
    
                            console.log("Filtered SubAccount IDs:", val);
                            console.log("Unique Account Nos (data-accno):", uniqueAccnos);
    
                            const d = { ...data, subAccountId: val, Account: uniqueAccnos };
                            if (val) {
                                //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                                console.log(locs);
                                if (locs && locs.length > 0) {
                                    
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                    d.LocationID = []
                                }
                            } else {
                                setLocations([]);
                                //d.isCod = null;
                            }
                            dispatch(setData({ data: d}));
                        }}>
                            {
                                subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                            }
                        </select>
                    </div>
    
                    <div className="col">
                        <label>Location</label>
                        <select className="form-select" multiple value={data.LocationID} onChange={async (e) => {
                            let val = Array.from(e.target.selectedOptions, option => +option.value);
                            dispatch(setData({ data: { ...data, LocationID: val }}));
                        }}>
                            {
                                locations.length > 0 && locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                </div>
                <div className="row pb-2">
                    {/* <div className="col">
                        <label>Accounts</label>
                        <select className="form-select" value={data.accountNo} onChange={e => updateData('accountNo', e.target.value)}>
                            {accounts.length > 1 && <option value={accounts.join(',')}>Select All</option>}
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div> */}
                    <div className="col">
                        <label>From</label>
                        <input type="date" className="form-control" value={data.from} onChange={e => updateData('from', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>To</label>
                        <input type="date" className="form-control" value={data.to} onChange={e => updateData('to', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>CN</label>
                        <input type="text" className="form-control" maxLength={15} onInput={processInt} value={data.cn} onChange={e => updateData('cn', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>Type</label>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            marginTop: 10
                        }}>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={data.type === 1} onChange={e => updateData('type', 1)} />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                    Open
                                </label>
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={data.type !== 1} onChange={e => updateData('type', 2)} />
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Close
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <button type="button" className="btn btn-primary" style={{ marginTop: 20 }} onClick={onSearch}>Search</button>
                    </div>
                </div>
            </div>

        }
        {
            originalGrid.length > 0 && <Grid />
        }
    </>
}

export default Form;
